export default __webpack_public_path__ + "static/media/nashikqr.b08136d7.png";